import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {WindowRefService, ComparatorsService, SiteInfosService} from '@app/core';
import {ICombineEngine} from '@app/shared';
import * as moment from 'moment';
import {map} from 'lodash';

@Component({
    selector: 'app-snapshat',
    templateUrl: './snapshat.component.html',
    styleUrls: ['./snapshat.component.scss']
})
export class SnapshatComponent implements OnInit {
    data: any;
    engine: ICombineEngine;
    url: SafeResourceUrl;
    nbrNights: number;
    currencyEtab: string;
    constructor(private winRef: WindowRefService, private siteInfosService: SiteInfosService, private dialogRef: MatDialogRef<SnapshatComponent>, @Inject(MAT_DIALOG_DATA) data: any, private comparatorsService: ComparatorsService, private sanitizer: DomSanitizer) {
        this.engine = data.engine;
        this.currencyEtab = this.siteInfosService.getEtabCurrency();
    }

    ngOnInit() {
        const alias = this.engine.alias == 'g' || this.engine.alias == 'p' ? 'b' : this.engine.alias;
        let ota = this.comparatorsService.getDataOta(alias),
        obj = {
            devise: this.Ccurrency,
            engine: this.engine.combine.ota,
            id: this.engine.combine.serial,
            lang: this.winRef.appConfigSite.defaultlangue,
            // server: ota.s,
            start: moment(this.winRef.appConfigSite.start).locale('en').format('YYYY-MM-DD'),
            uid: this.engine.combine.uid,
            // url: ota.url,
            hi : this.winRef.appConfigSite.hi ? '1' : '0',
        };
        let s = this.winRef.appConfigSite.host.concat("en/capture-booking/", ota.otaEnvEtab.toString(), "?", map(obj, (v, k) => encodeURIComponent(k) + '=' + encodeURIComponent(v)).join('&'));
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(s);
        this.nbrNights = this.winRef.nbrNights();
    }

    /**
    * get taux de change
    * @returns number
    */
    get Cpercente(): number {
        return this.winRef.appConfigSite.Cpercente;
    }

    /**
     * get currency
     * @returns string
     */
    get Ccurrency(): string {
        return this.winRef.appConfigSite.Ccurrency;
    }
    
    /**
    * lang
    * @returns string lang
    */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

}
